import $api from '../services';

export default {
    list(params) {
        return $api.get('/landing-pages', params);
    },
    create(params) {
        return $api.post('/landing-pages', params);
    },
    read(id) {
        return $api.get(`/landing-pages/${id}`);
    },
    readPublic(id) {
        return $api.get(`/landing-pages-public/${id}`);
    },
    update(id, params) {
        return $api.put(`/landing-pages/${id}`, params);
    },
    delete(id) {
        return $api.delete(`/landing-pages/${id}`);
    }
};
